import { CognitoAuthService } from "./cognitoService";
import {
  fetchUserById,
  updateUser,
} from "../features/user-management/services/userService";
import type { ThemeMode } from "../theme/themeTokens";
import { isThemeMode } from "../theme/themeTokens";
import { debug } from "../utils/debugLogger";

/**
 * Persists UI theme preference on the user record (users API).
 * Backend must accept optional `ui_theme_preference`; failures are swallowed so local theme still works.
 */
export async function persistUiThemePreference(
  mode: ThemeMode,
  idToken: string
): Promise<void> {
  const sub = CognitoAuthService.getUserId(idToken);
  if (!sub) return;
  try {
    const user = await fetchUserById(sub, idToken);
    await updateUser({ ...user, ui_theme_preference: mode }, idToken);
  } catch (e) {
    debug.warn("Could not persist theme preference to server:", e);
  }
}

export function parseUiThemePreference(
  value: unknown
): ThemeMode | undefined {
  return isThemeMode(value) ? value : undefined;
}
